import { cn } from '@/lib/utils'

/**
 * The WP eagle in brand orange on no ground of its own — the same mark in the sidebar and on the
 * signed-out pages, and the way the WP web portal draws it, so moving between the two reads as one
 * family. The favicon shows the same eagle but is a file of its own, public/favicon.ico: a change
 * here does not reach it.
 *
 * The orange is the brand's `#ed8c00`, hard-coded rather than `--primary`: the mark is the brand's
 * and must not turn a different colour if that token is ever repointed. Nothing here is read: the
 * mark is decorative and every caller renders the product name next to it as real text
 * (WCAG 1.4.3).
 *
 * Inline rather than an `<img>`: it is two shapes, it must not flash in after the page, and a
 * request for it would be one more thing that can 404 in a subdirectory deployment.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn('flex size-8 shrink-0 items-center justify-center', className)}
    >
      {/* The asset's own padding is cropped away: it is meant for an app icon standing on its own
          and would leave the eagle small and lost next to text. With no tile around it any more,
          this box is the eagle's bounding box (5.79 8.61 20.41 14.78) centred in a square with
          just half a unit to spare, so the eagle spans nearly the full width of the box. */}
      <svg
        viewBox="5.29 5.29 21.41 21.41"
        // `!` because a sidebar menu button sizes every svg inside it to an icon's 16px, which would
        // shrink the logo to that whatever size its box is given.
        className="size-full!"
        role="presentation"
        focusable="false"
      >
        <path
          fill="#ed8c00"
          d="m 7.679436,12.49684 c 0,0 -0.03857,1.791656 1.971393,1.975537 h 1.547114 L 10.477956,10.658034 H 9.243693 a 1.6499704,1.8152316 0 0 0 -1.547115,1.84352 m 13.144049,1.956678 h 1.547115 c 2.005679,-0.226314 1.962823,-1.975537 1.962823,-1.975537 A 1.6285422,1.7916571 0 0 0 22.84202,10.59674 H 21.5949 Z M 5.793755,12.407257 A 3.5485077,3.9039265 0 0 1 8.969412,8.611771 h 4.109926 v 1.862382 h -0.857127 l 1.422831,6.577267 2.395671,-8.368925 2.382815,8.36421 1.375689,-6.530118 H 18.94209 V 8.682495 h 4.088498 a 3.5185083,3.8709223 0 0 1 3.175657,3.795485 3.5485077,3.9039265 0 0 1 -3.389939,3.795484 l -2.421385,0.141446 -1.024267,4.969492 h 0.711416 v 2.003827 h -3.209943 v -2.107555 h 0.8357 l -1.757112,-6.020911 -1.752825,6.020911 h 0.835699 v 2.027401 h -3.214228 v -2.027401 h 0.702844 L 11.54508,16.315898 9.166552,16.268748 A 3.6256492,3.9887944 0 0 1 5.793755,12.407257"
        />
      </svg>
    </span>
  )
}
